module.exports = __webpack_public_path__ + "static/media/averta-semibold.d774c54a.woff";